import React from 'react';
import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { msalInstance } from './auth';
import LoginPage from './components/LoginPage';
import Header from './components/Header';
import LandingPage from './pages/LandingPage';

/**
 * Root application component.
 *
 * Wraps the entire tree in MsalProvider for Azure AD authentication.
 *   - Unauthenticated → LoginPage
 *   - Authenticated   → Header + LandingPage
 */
export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <Header />
        <LandingPage />
      </AuthenticatedTemplate>
    </MsalProvider>
  );
}
